const doctorsStrings = {
  doctorsFilter: {
    searchBarPlaceholder: 'Doctor Name, Email or Entity',
  },

  doctorsList: {
    doctorsGridNoResultsFound: 'No results matching your search criteria',
    doctorsGridHeader: {
      doctorsUserIdGridHeader: 'User ID',
      doctorsProfileIdGridHeader: 'Profile ID',
      doctorsDetailsGridHeader: 'Name',
      doctorsMobileGridHeader: 'Mobile',
      doctorsSpecialtyGridHeader: 'Specialty',
      doctorsCountryGridHeader: 'Country',
      doctorsNationalityGridHeader: 'Nationality',
      doctorsEntityDetailsGridHeader: 'Entity',
      doctorsLicenceGridHeader: 'Licence',
      doctorsActionsGridHeader: 'Actions',
    },
    doctorsLicenceGridItem: 'Licence',
    copiedToClipboardText: 'Copied to clipboard 🚀',
    showNumberText: 'Show Number',
    doctorsGridVerifyActionBtn: 'Verify',
    doctorsGridRejectActionBtn: 'Reject',
    doctorsGridAddBadgeActionBtn: 'Badges',
    doctorsGridRemoveBadgeActionBtn: 'Remove Badge',
    actionPopupTitle(status) {
      return `Are you sure you want to mark this doctor as ${status} ?`;
    },
    badgePopupTitle(status) {
      return `Are you sure you want to give this doctor ${status} badge ?`;
    },
    actionPopupYesBtn: 'Yes',
    actionPopupNoBtn: 'No',
    badgePopupAssignBtn: 'Assign',
    badgePopupRevokeBtn: 'Revoke',
  },
};

export default doctorsStrings;
